var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        titulo: "Visualizar solicitações",
        width: _vm.width,
        height: 700,
        bodyStyle: { height: "auto", padding: "0" }
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _vm.showModalVisualizaPdf
            ? _c("app-modal-visualiza-pdf", {
                attrs: {
                  titulo: _vm.tituloModal,
                  tipo: _vm.tipoModal,
                  conteudo: _vm.conteudoModal,
                  isVTN: false,
                  isImagem: _vm.isImagem,
                  tituloDocumento: _vm.tituloDocumento
                },
                on: { closeModal: _vm.closeModalVisualizaPdf }
              })
            : _vm._e(),
          _vm._l(_vm.solicitacoesInformacao, function(item) {
            return _c(
              "div",
              { key: item.id, staticClass: "extra-margin-bottom" },
              [
                _c("p", { staticClass: "bold" }, [
                  _vm._v("Solicitações:   Informação")
                ]),
                _c(
                  "el-collapse",
                  {
                    model: {
                      value: _vm.abaAtiva,
                      callback: function($$v) {
                        _vm.abaAtiva = $$v
                      },
                      expression: "abaAtiva"
                    }
                  },
                  [
                    _c(
                      "el-collapse-item",
                      [
                        _c("template", { slot: "title" }, [
                          _c("div", { staticClass: "flex title full-width" }, [
                            _c("span", [_vm._v(_vm._s(item.responsavel))]),
                            _c("span", { staticClass: "date" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatData(item.requerimento.dataEnviada)
                                ) + "  "
                              )
                            ])
                          ])
                        ]),
                        _c("app-display", {
                          attrs: {
                            label: "Setor Origem:",
                            content: item.setorOrigem
                          }
                        }),
                        _c("app-display", {
                          attrs: {
                            label: "Setor Requerido:",
                            content: item.setorRequerido
                          }
                        }),
                        _c("app-display", {
                          attrs: {
                            label: "Responsável:",
                            content: item.responsavel
                          }
                        }),
                        _c("app-display", {
                          attrs: {
                            label: "Data de Vencimento:",
                            content: _vm.formatData(item.dataVencimento)
                          }
                        }),
                        _c("p", [_c("b", [_vm._v("Despacho:")])]),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(item.requerimento.conteudo)
                          }
                        }),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-table",
                              {
                                attrs: {
                                  data: item.requerimento.anexoList,
                                  stripe: "stripe"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "empty" }, slot: "empty" },
                                  [
                                    _c("span", [
                                      _vm._v("Não há anexos disponíveis.")
                                    ])
                                  ]
                                ),
                                _c("el-table-column", {
                                  staticClass: "td-column-anexo",
                                  attrs: { prop: "nome" }
                                }),
                                _c("el-table-column", {
                                  staticClass: "td-column-anexo",
                                  attrs: { align: "center", width: "85" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "btn-actions",
                                                attrs: {
                                                  effect: "dark",
                                                  content: !_vm.isDocumentoParaVisualizacao(
                                                    scope.row
                                                  )
                                                    ? "Não é possível exibir esse arquivo"
                                                    : "Visualizar Documento",
                                                  placement: "left"
                                                }
                                              },
                                              [
                                                scope.row &&
                                                (_vm.isEstadoMA ||
                                                  _vm.isEstadoAP)
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        staticClass: "button",
                                                        attrs: {
                                                          disabled: !_vm.isDocumentoParaVisualizacao(
                                                            scope.row
                                                          )
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.abrirDocumento(
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "eye",
                                                              size: "lg"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _c("app-action-button", {
                                              attrs: {
                                                icone: "download",
                                                nome: "file_download",
                                                hoverColor: "#009f61",
                                                text: "Baixar anexo"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.baixarAnexo(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-collapse",
                          {
                            staticClass: "collapse",
                            model: {
                              value: _vm.abaAtiva,
                              callback: function($$v) {
                                _vm.abaAtiva = $$v
                              },
                              expression: "abaAtiva"
                            }
                          },
                          _vm._l(item.mensagemList, function(msg) {
                            return _c(
                              "el-collapse-item",
                              { key: msg.id, attrs: { name: msg.id } },
                              [
                                _c("template", { slot: "title" }, [
                                  _c(
                                    "div",
                                    { staticClass: "flex title full-width" },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(msg.nomeRemetente))
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatData(msg.dataEnviada)
                                          ) + "  "
                                        )
                                      ])
                                    ]
                                  )
                                ]),
                                _c("el-row", { staticClass: "margin-top" }, [
                                  _c("p", [_c("b", [_vm._v("Resposta:")])]),
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(msg.conteudo)
                                    }
                                  })
                                ]),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        attrs: {
                                          data: msg.anexoList,
                                          stripe: "stripe"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "empty" },
                                            slot: "empty"
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "Não há anexos disponíveis."
                                              )
                                            ])
                                          ]
                                        ),
                                        _c("el-table-column", {
                                          staticClass: "td-column-anexo",
                                          attrs: { prop: "nome" }
                                        }),
                                        _c("el-table-column", {
                                          staticClass: "td-column-anexo",
                                          attrs: {
                                            align: "center",
                                            width: "85"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _c("el-tooltip", {
                                                      staticClass:
                                                        "btn-actions",
                                                      attrs: {
                                                        effect: "dark",
                                                        content: !_vm.isDocumentoParaVisualizacao(
                                                          scope.row
                                                        )
                                                          ? "Não é possível exibir esse arquivo"
                                                          : "Visualizar Documento",
                                                        placement: "left"
                                                      }
                                                    }),
                                                    scope.row &&
                                                    (_vm.isEstadoMA ||
                                                      _vm.isEstadoAP)
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "button",
                                                            attrs: {
                                                              disabled: !_vm.isDocumentoParaVisualizacao(
                                                                scope.row
                                                              )
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.abrirDocumento(
                                                                  scope.row
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "font-awesome-icon",
                                                              {
                                                                attrs: {
                                                                  icon: "eye",
                                                                  size: "lg"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _c("app-action-button", {
                                                      attrs: {
                                                        icone: "download",
                                                        nome: "file_download",
                                                        hoverColor: "#009f61",
                                                        text: "Baixar anexo"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.baixarAnexo(
                                                            scope.row
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          }),
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca0353f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca0353f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/components/gerais/AppModalListaSolicitacoesInformacao.vue
// module id = null
// module chunks = 